import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

normalizeHashRoutePath();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

function normalizeHashRoutePath(): void {
  if (!window.location.hash?.startsWith("#/")) {
    return;
  }

  const currentHash = window.location.hash.substring(2);
  const [pathPart, queryPart] = currentHash.split("?", 2);
  const normalizedPath = pathPart.replace(
    /(^|\/)([^\/;?#]+)/g,
    (_, prefix: string, segment: string) => `${prefix}${segment.toLowerCase()}`
  );

  if (normalizedPath === pathPart) {
    return;
  }

  const normalizedHash = queryPart !== undefined
    ? `#/${normalizedPath}?${queryPart}`
    : `#/${normalizedPath}`;

  window.location.replace(`${window.location.pathname}${window.location.search}${normalizedHash}`);
}

if ('caches' in window) {
  caches.keys().then(function (names) {
    for (let name of names) {
      caches.delete(name);
    }
  });
}